import React from "react";
import { WSAlert, WSMarginProps } from "@wingspanhq/fe-component-library";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../../query/users/queries";
import { CompanyStructure } from "@wingspanhq/users/dist/lib/interfaces";

export const InfoBoxCCorpTaxLimitations: React.FC<WSMarginProps> = props => {
  const userId = useUserId();
  const queryMember = useQueryMemberProfile(userId);
  const isCCorp =
    queryMember.data?.profile.company?.structure ===
    CompanyStructure.CorporationC;

  if (!isCCorp) {
    return null;
  }

  return (
    <WSAlert
      theme="info"
      icon="info-circle"
      title="Limitations on tax payments for C-corps"
      {...props}
    >
      As a C-corporation, you can set aside funds using this Tax Withholdings
      account for fund management and invoice splits. Tax payments cannot be
      sent through this account and will require separate filing through your
      tax professional or the IRS directly with your C-corp information. Please
      consult with a tax professional to choose the most suitable filing options
      for your business.
    </WSAlert>
  );
};
